import { Engine } from 'engine/Engine';
import React from 'react';
import { UIFacet } from '../facets/UIFacet';

interface UIRendererProps {
  engine: Engine,
}

// eslint-disable-next-line react/prefer-stateless-function
export class UIRenderer extends React.Component<UIRendererProps> {
  render() {
    const { engine } = this.props;
    return (
      <>
        {engine.entities.map(e => (
          e.getFacets(UIFacet).map((f, i) => (
            <f.props.Component key={i} />
          ))
        ))}
      </>
    );
  }
}
